import { useState, useEffect } from 'react';
import { getPublicAvatarUrl } from '../utils/publicAvatarUtils';

// 메모리 캐시 (세션 동안 유지)
const imageCache = new Map();

export const useCachedAvatar = (userID, fallbackUrl = null, size = 160) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadAvatar = async () => {
      if (!userID) {
        setImageSrc(fallbackUrl);
        setLoading(false);
        return;
      }

      // 1. 메모리 캐시 확인 (로딩 상태 변경 전)
      const cacheKey = `${userID}_${size}`;
      const cachedUrl = imageCache.get(cacheKey);
      if (cachedUrl) {
        setImageSrc(cachedUrl);
        setLoading(false);
        setError(false);
        return;
      }

      // 캐시가 없는 경우에만 로딩 상태 시작
      setLoading(true);
      setError(false);

      try {
        // 2. Firebase Storage URL 생성 (지정된 크기)
        const publicUrl = getPublicAvatarUrl(userID, size);
        
        // 3. 이미지 로드 확인
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
          // 메모리 캐시에 저장 (크기별로 캐시)
          imageCache.set(cacheKey, publicUrl);
          
          // 지정된 크기로 표시
          setImageSrc(publicUrl);
          setLoading(false);
        };
        
        img.onerror = () => {
          setError(true);
          setImageSrc(fallbackUrl);
          setLoading(false);
        };
        
        img.src = publicUrl;
        
      } catch (error) {
        console.error('Avatar loading failed:', error);
        setError(true);
        setImageSrc(fallbackUrl);
        setLoading(false);
      }
    };

    loadAvatar();
  }, [userID, fallbackUrl, size]);

  return { imageSrc, loading, error };
};